import React from 'react';
import FormModal from './FormModal';

interface DocumentPreviewModalProps {
  open: boolean;
  title: string;
  filename?: string | null;
  objectUrl?: string;
  contentType?: string;
  loading?: boolean;
  error?: string;
  onClose: () => void;
}

const isPdfDocument = (contentType?: string, filename?: string | null): boolean =>
  Boolean(contentType?.toLowerCase().includes('pdf') || filename?.toLowerCase().endsWith('.pdf'));

const isImageDocument = (contentType?: string, filename?: string | null): boolean =>
  Boolean(contentType?.toLowerCase().startsWith('image/') || /\.(jpe?g)$/i.test(filename || ''));

const DocumentPreviewModal: React.FC<DocumentPreviewModalProps> = ({
  open,
  title,
  filename,
  objectUrl,
  contentType,
  loading = false,
  error,
  onClose,
}) => (
  <FormModal
    open={open}
    title={title}
    description={filename || 'ARE document preview'}
    onClose={onClose}
    closeLabel="Close document preview"
    size="lg"
  >
    <div className="document-preview">
      {loading ? <p className="records-table-muted">Loading document preview...</p> : null}
      {error ? <div className="error-message" role="alert"><span className="error-body">{error}</span></div> : null}
      {!loading && !error && objectUrl && isImageDocument(contentType, filename) ? (
        <img className="document-preview-image" src={objectUrl} alt={`Preview of ${filename || 'ARE document'}`} />
      ) : null}
      {!loading && !error && objectUrl && isPdfDocument(contentType, filename) ? (
        <iframe className="document-preview-frame" title={`${filename || 'ARE document'} preview`} src={objectUrl} />
      ) : null}
      {!loading && !error && objectUrl && !isImageDocument(contentType, filename) && !isPdfDocument(contentType, filename) ? (
        <p className="records-table-muted">Preview is not available for this document type.</p>
      ) : null}
      {objectUrl ? (
        <a className="btn btn-secondary" href={objectUrl} target="_blank" rel="noreferrer">
          Open document in new tab
        </a>
      ) : null}
    </div>
  </FormModal>
);

export default DocumentPreviewModal;

